require.register("modules/m03/m03-activity/page-14_il/page-14_il", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page14_il = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page14_il;

  
});

